import { Component, Input } from '@angular/core';
import { Params } from '@angular/router';

import { HisNavigationService } from 'hisng';

@Component( {
    selector: 'res-publication-duplicates-button',
    templateUrl: './publication-duplicates-button.component.html',
} )
export class PublicationDuplicatesButtonComponent {

    @Input() row: any;

    // ein Diskriminator für die Seite, von der die Duplikatsseite aufgerufen wurde: "pubSearch" oder "importCandidates"
    @Input() prevPage: string;

    constructor( private navigationService: HisNavigationService ) {}

    createDuplicatesQueryParams(row: any): Params {
        return {
            configFile: 'fs/res/searchPublicationDuplicates.xml',
            pageTitle: 'cs.sys.duplicates.check.duplicatesPageTitle',
            // tableTitle not required here, a customListTitle will be defined in the publication-import-duplicates-search-result component
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'Publication.id': row.get('duplicateIds'),
            prevPage: this.prevPage
        };
    }

    /** Store current url in SessionStorage for back button on next page */
    onBeforeNavigate() {
        this.navigationService.setLastBackUrl(window.location.href);
    }
}
